"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PollTransform = exports.PollEvent = exports.PollController = void 0;
exports.poll = poll;
var _nodeStream = require("node:stream");
let PollEvent = exports.PollEvent = /*#__PURE__*/function (PollEvent) {
  PollEvent["Poll"] = "poll";
  return PollEvent;
}({});
class PollController extends _nodeStream.EventEmitter {
  poll() {
    this.emit(PollEvent.Poll);
  }
}
exports.PollController = PollController;
class PollTransform extends _nodeStream.Transform {
  constructor(controller, options = {}) {
    super({
      objectMode: true,
      ...options
    });
    this.buffer = [];
    this.controller = controller;
    this.controllerCallback = () => this.poll();
    this.pollers = [];
    this.controller?.on(PollEvent.Poll, this.controllerCallback);
  }
  dispose() {
    // Disable the controller
    this.controller?.off(PollEvent.Poll, this.controllerCallback);
    this.controller = undefined;
    this.controllerCallback = undefined;

    // Drop any transform callback
    this.transformCallback = undefined;

    // Resolve pollers and discard remaining chunks
    this.process();
    this.buffer.length = 0;

    // Resolve remaining pollers
    const error = this.errored ?? undefined;
    while (this.pollers.length > 0) {
      const poller = this.pollers.pop();
      poller(error);
    }
  }
  _destroy(_error, callback) {
    this.dispose();
    this.push(null);
    callback();
  }
  async poll() {
    return new Promise((resolve, reject) => {
      if (!this.closed) {
        this.pollers.push((error, chunk) => error ? reject(error) : resolve(chunk));
        this.process();
      } else if (this.errored != null) {
        reject(this.errored);
      } else {
        resolve(undefined);
      }
    });
  }
  process() {
    while (this.buffer.length > 0 && this.pollers.length > 0) {
      const chunk = this.buffer.shift();
      const poller = this.pollers.shift();
      poller(undefined, chunk);
      this.push(chunk);
    }
    if (this.pollers.length > 0 && this.transformCallback != null) {
      const callback = this.transformCallback;
      this.transformCallback = undefined;
      callback();
    }
  }
  _transform(chunk, _encoding, callback) {
    if (this.destroyed) {
      callback();
      return;
    }
    this.buffer.push(chunk);
    this.transformCallback = callback;
    this.process();
  }
}
exports.PollTransform = PollTransform;
function poll(controller) {
  return new PollTransform(controller);
}